module.exports = __webpack_public_path__ + "static/media/airstrikehalf.399d50d0.ttf";